import React from "react";
import { Pie } from "react-chartjs-2";
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";

// Register the datalabels plugin
Chart.register(ChartDataLabels);

const PieChart = ({ data }) => {
  const maxGroups = 6;
  let processedData = [...data];

  if (processedData.length > maxGroups) {
    // Sort data by value in ascending order
    processedData.sort((a, b) => a.value - b.value);

    // Take the smallest groups and sum their values
    let otherTotal = 0;
    for (let i = 0; i < processedData.length - (maxGroups - 1); i++) {
      otherTotal += processedData[i].value;
    }

    // Keep only the largest groups and add the "Other" group
    processedData = [
      ...processedData.slice(processedData.length - (maxGroups - 1)),
      { label: "Other", value: otherTotal },
    ];
  }

  const getLabelsFontSize = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth <= 600) {
      // Small screen
      return 0;
    } else if (screenWidth <= 1200) {
      // Medium screen
      return 10;
    } else {
      // Large screen
      return 12;
    }
  };

  const chartData = {
    labels: processedData.map((item) => item.label),
    datasets: [
      {
        label: "Learning Zones Distribution",
        data: processedData.map((item) => item.value),
        backgroundColor: [
          "rgba(255, 99, 132, 0.6)",
          "rgba(54, 162, 235, 0.6)",
          "rgba(255, 206, 86, 0.6)",
          "rgba(75, 192, 192, 0.6)",
          "rgba(153, 102, 255, 0.6)",
          "rgba(255, 159, 64, 0.6)",
          "rgba(100, 100, 100, 0.6)", // Color for "Other"
        ],
        borderWidth: 1,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        labels: {
          padding: 10,
          usePointStyle: true,
          color: "#1f0c53",
          font: {
            size: 14,
            family: "Arial",
          },
        },
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            let label = tooltipItem.label || "";
            if (label) {
              label += ": ";
            }
            const total = tooltipItem.dataset.data.reduce(
              (acc, curr) => acc + curr,
              0
            );
            const currentValue = tooltipItem.raw;
            const percentage = ((currentValue / total) * 100).toFixed(1);
            label += `${percentage}%`;
            return label;
          },
        },
      },
      datalabels: {
        color: "#ffffff",
        anchor: "end",
        align: "start",
        formatter: function (value, context) {
          const numValue = Number(value);
          return `${
            context.chart.data.labels[context.dataIndex]
          }: ${numValue.toFixed(1)}%`;
        },
        font: {
          size: getLabelsFontSize(),
        },
      },
    },
    layout: {
      padding: {
        top: 20,
      },
    },
  };

  return <Pie data={chartData} options={chartOptions} />;
};

export default PieChart;
